import React from 'react';
import { RichText } from 'prismic-reactjs';
import KeywordGrid from '@components/keyword-grid';
import Grid from '@components/grid';
import { GridItem, StyledDescription } from '@components/grid/grid.styled';
import Button from '@components/button';
import DownloadOverlay from '@components/download-overlay';
import Image from '@components/image';
import Color from '@components/color';
import Text from '@components/paragraphs/text';
import { ColorsGrid, RichTextGrid, RichTextContentGrid, ButtonWrapper, MediaWrap } from './module.styled';
var renderModule = function renderModule(type, label, primary, items) {
    var getButton = function getButton() {
        if (primary && primary.group_download_link && primary.group_download_link.url !== '') {
            var url = primary.group_download_link.url;
            return /*#__PURE__*/ React.createElement(ButtonWrapper, null, /*#__PURE__*/ React.createElement(Button, {
                label: primary.group_download_label || 'Download',
                onClick: function onClick() {
                    return window.open(url);
                },
                width: 10.87
            }));
        }
        return null;
    };
    switch (type) {
        case 'keyword_grid':
            return /*#__PURE__*/ React.createElement(KeywordGrid, {
                items: items || []
            });
        case 'media_blocks':
            return /*#__PURE__*/ React.createElement(MediaWrap, null, /*#__PURE__*/ React.createElement(Grid, {
                itemsPerRow: label && +label.slice(0, 1) || 3
            }, items.map(function (_ref, id) {
                var block_media = _ref.block_media, media_caption = _ref.media_caption, block_download_label = _ref.block_download_label, block_download_link = _ref.block_download_link;
                var key = "" + id + block_media.url;
                var image = /*#__PURE__*/ React.createElement(Image, {
                    fluid: block_media === null || block_media === void 0 ? void 0 : block_media.fluid,
                    alt: block_media.alt,
                    imageUrl: block_media.url
                });
                return /*#__PURE__*/ React.createElement(GridItem, {
                    key: key
                }, block_download_link && block_download_link.url !== null ? /*#__PURE__*/ React.createElement(DownloadOverlay, {
                    url: block_download_link.url,
                    label: block_download_label || 'Download'
                }, image) : image, media_caption && media_caption.text !== '' ? /*#__PURE__*/ React.createElement(StyledDescription, null, media_caption.text) : null);
            })), getButton());
        case 'color_blocks':
            return /*#__PURE__*/ React.createElement(ColorsGrid, null, items.map(function (_ref2, id) {
                var color_name = _ref2.color_name, color_preview = _ref2.color_preview;
                var key = "" + id + color_name;
                return /*#__PURE__*/ React.createElement(Color, {
                    key: key,
                    name: color_name,
                    HEX: color_preview
                });
            }));
        case 'rich_text_guideline':
            return /*#__PURE__*/ React.createElement(RichTextContentGrid, {
                itemsPerRow: 1
            }, items.map(function (_ref3, id) {
                var content = _ref3.content, text_size = _ref3.text_size, bullet_style = _ref3.bullet_style;
                var key = "" + id + content.text;
                return /*#__PURE__*/ React.createElement(Text, {
                    key: key,
                    richText: content === null || content === void 0 ? void 0 : content.raw,
                    textType: text_size,
                    bulletType: bullet_style
                });
            }));
        case 'ordered_rich_text_blocks':
            return /*#__PURE__*/ React.createElement(RichTextGrid, {
                itemsPerRow: label && +label.slice(0, 1) || 3
            }, items.map(function (_ref4, id) {
                var image = _ref4.image, content = _ref4.content;
                var key = "" + id + image.url;
                return /*#__PURE__*/ React.createElement(GridItem, {
                    key: key
                }, image.url !== null && /*#__PURE__*/ React.createElement(Image, {
                    fluid: image.fluid,
                    alt: image.alt,
                    imageUrl: image.url
                }), content ? /*#__PURE__*/ React.createElement(RichText, {
                    render: content.raw
                }) : null);
            }));
        default:
            return null;
    }
};
export default renderModule;
